import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import ListingPage from '../2/Controls/ListingPage';
import { exportFile } from '../../actions/DataExporter';

class UniqueNoLedger extends Component {
    constructor() {
        super()
        this.state = {
            uniqueNoLedger: [],
            loading: true,
            activePage: 1,
            itemsCountPerPage: 25,
            totalItemsCount: 0,
            paginationStatus: ""
        }
        this.loadUniqueNoLedger = this.loadUniqueNoLedger.bind(this)
        this.handlePageChange = this.handlePageChange.bind(this)
        this.onExportClick = this.onExportClick.bind(this)
    }

    componentDidMount() {
        this.loadUniqueNoLedger()
    }

    loadUniqueNoLedger() {
        this.setState({ loading: true })
        this.props.getUniqueNoLedger(this.props.location.state.data.key).then((result) => {
            this.setState({ 
                uniqueNoLedger: result, 
                loading: false,
                totalItemsCount: result.length
            })
        })
    }

    handlePageChange(pageNumber) {
        this.setState({ activePage: pageNumber });
        // Implement pagination logic here if needed
    }

    // Define column configuration for ListingPage
    getColumns() {
        return [
               {
            Name: "Store Name",
            Type: "field",
            Columns: [{ Column: "StoreName" }],
          },
              {
            Name: "Brand",
            Type: "field",
            Columns: [{ Column: "ProductBrand" }],
          },
           {
            Name: "Category",
            Type: "field",
            Columns: [{ Column: "ProductCategory" }],
          },
           {
            Name: "Sub Category",
            Type: "field",
            Columns: [{ Column: "ProductSubCategory" }],
          },

           {
            Name: "SKU",
            Type: "field",
            Columns: [{ Column: "ProductSKU" }],
          },

             {
            Name: "Barcode",
            Type: "field",
            Columns: [{ Column: "ProductBarCode" }],
          },

           {
            Name: "Product Name",
            Type: "field",
            Columns: [{ Column: "ProductName" }],
          },

            {
            Name: "Supply Price",
            Type: "field",
            Columns: [{ Column: "SupplyPrice" }],
          },
           {
            Name: "Unique No 1",
            Type: "field",
            Columns: [{ Column: "UniqueNo1" }],
          },
           {
            Name: "Unique No 2",
            Type: "field",
            Columns: [{ Column: "UniqueNo2" }],
          },
           {
            Name: "Unique No 3",
            Type: "field",
            Columns: [{ Column: "UniqueNo3" }],
          },
           {
            Name: "Unique No 4",
            Type: "field",
            Columns: [{ Column: "UniqueNo4" }],
          },
          
             {
            Name: "Inward Amount",
            Type: "number",
            Columns: [{ Column: "InWardAmount" }],
          },
             {
            Name: "Outward Amount",
            Type: "number",
            Columns: [{ Column: "OutWardAmount" }],
          },
              {
            Name: "Transaction No",
            Type: "field",
            Columns: [{ Column: "TransactionNo" }],
          },
            
          
              {
            Name: "Transaction Type",
            Type: "field",
            Columns: [{ Column: "TransactionType" }],
          },
             {
        Name: "Date",
        Column: "Date",
        Type: "custom",
        renderCell: ({ row }) => {
          return (
            <div >
            {new Date(row.ActionOn._seconds * 1000).toString().substring(0, 24)}
            </div>
          );
        },
      },
          
            {
                Name: "Movement",
                Type: "field",
            Columns: [{ Column: "Movement" }]
            }
        ];
    }

    // Define export columns configuration
    getExportColumns() {
        return [
            { header: "Store Name", field: "StoreName" },
            { header: "Brand", field: "ProductBrand" },
            { header: "Category", field: "ProductCategory" },
            { header: "Sub Category", field: "ProductSubCategory" },
            { header: "SKU", field: "ProductSKU" },
            { header: "Barcode", field: "ProductBarCode" },
            { header: "Name", field: "ProductName" },
            { header: "Supply Price", field: "SupplyPrice" },
            { header: "UniqueNo 1", field: "UniqueNo1" },
            { header: "UniqueNo 2", field: "UniqueNo2" },
            { header: "UniqueNo 3", field: "UniqueNo3" },
            { header: "UniqueNo 4", field: "UniqueNo4" },
            { header: "Transaction No", field: "TransactionNo" },
            { header: "Transaction Type", field: "TransactionType" },
            { 
                header: "Action On", 
                field: "ActionOn",
                type: "date",
                formatter: function(value) {
                    if (value && value._seconds) {
                        return new Date(value._seconds * 1000).toString().substring(0, 24);
                    }
                    return "";
                }
            },
            { header: "Movement", field: "Movement" }
        ];
    }

    // Prepare data for ListingPage
    prepareData() {
        return this.state.uniqueNoLedger.map(ledger => ({
            ...ledger,
            StoreName: this.props.user.store.StoreName,
            InWardAmount: ledger.InWardAmount || 0,
            OutWardAmount: ledger.OutWardAmount || 0,
            SupplyPrice: ledger.SupplyPrice || 0,
            TransactionDate: ledger.ActionOn ? new Date(ledger.ActionOn._seconds * 1000).toString().substring(0, 24) : ""
        }));
    }

    // Export functionality using the export utility
    onExportClick() {
        const exportColumns = this.getExportColumns();
        const exportData = this.state.uniqueNoLedger.map(ledger => ({
            ...ledger,
            StoreName: this.props.user.store.StoreName,
            SupplyPrice: ledger.SupplyPrice || 0
        }));

        exportFile({
            data: exportData,
            columns: exportColumns,
            fileType: "CSV", // Can be "CSV", "EXCEL", or "PDF"
            title: "Unique Ledger",
            landscape: false
        });
    }

    render() {
        const listPageSettings = {
            Title: "Unique No Ledger",
            Columns: this.getColumns(),
            RowButtons: [
            ],
            HeaderButtons: [
                {
            ButtonType: "Button",
            Type: "primary",
            Text: "Export",
            Icon: "download",
            Action: "export",
            showInCompact: true,
           
          },

            ],
            Search: {
                showSearch: false
            }
        };

        return (
            <ListingPage
                {...this.props}
                listPageSettings={listPageSettings}
                list={this.prepareData()}
                loading={this.state.loading}
                totalItemsCount={this.state.totalItemsCount}
                itemsCountPerPage={this.state.itemsCountPerPage}
                recordFrom={(this.state.activePage - 1) * this.state.itemsCountPerPage}
                onPageChange={this.handlePageChange}
                onRecordsPerPageCountChange={(newCount) => {
                    this.setState({ itemsCountPerPage: newCount, activePage: 1 });
                }}
                onHeaderButtonClicked={(button) => {
                    if (button.Action === "export") {
                        this.onExportClick();
                    }
                }}
                enableSideBySide={false}
                onClose={() => this.props.history.push("/report?name=UniqueNo")}
            />
        );
    }
}

export default withRouter(UniqueNoLedger);